module.exports = __webpack_public_path__ + "img/01_no.21beaf47.svg";